"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributorsList = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const button_1 = require("client/components/material/button");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const switch_1 = require("client/components/material/switch");
const router_1 = require("client/components/router");
const store_1 = require("client/modules/inventory-order/store");
const store_2 = require("client/modules/users/store");
const material_ui_1 = require("material-ui");
const Collapse_1 = require("material-ui/transitions/Collapse");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const distributor_add_form_1 = require("../distributor-add-form");
const distributor_edit_form_1 = require("../distributor-edit-form");
const contact_email_1 = require("./components/contact-email");
const modal_1 = require("client/components/modal");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
require("./distributor-list.less");
const throttle_debounce_1 = require("throttle-debounce");
const text_field_small_1 = require("client/components/material/text-field/text-field-small");
const distributorColumns = [
    {
        id: "id",
        label: "distributor id"
    },
    {
        id: "distributor",
        label: "distributor name"
    },
    {
        id: "contact",
        label: "contact email"
    }
];
let DistributorsList = 
// export class DistributorsTab extends Component<IProps> {
class DistributorsList extends React.Component {
    constructor() {
        super(...arguments);
        this.selectedDistributor = null;
        this.distributorToAdd = "";
        this.order = "ASC";
        this.orderBy = "package";
        this.filterText = "";
        this.distributorsList = [];
        this.manageDistributorsMode = true;
        this.manageDistributorsPurchaseList = false;
        this.showDistributorRemoveConfirmation = false;
        this.showDistributorActivateConfirmation = false;
        this.distributorToRemove = null;
        this.distributorToActivate = null;
        this.showDistributorAddForm = false;
        this.showOverviewChildren = new Map();
        this.loading = false;
        this.showDisabled = false;
        // C-097_Distributors
        this.page = 1;
        this.limit = 25;
        this.totalPages = 1;
        // C-097_Distributors
        this.listDistributors = throttle_debounce_1.debounce(200, () => {
            const options = {
                page: this.page,
                limit: this.limit //For pagination //C-097
            };
            store_1.inventoryOrderStore.listDistributors(options);
        });
        // C-097_Distributor_UAT Disable 
        this.loadDistributors = async (options) => {
            await store_1.inventoryOrderStore.listDistributors(options);
            this.distributorsList = store_1.inventoryOrderStore.distributors;
        };
        // C-097_Distributor_UAT Disable 
        this.loadDeletedDistributors = async (options) => {
            await store_1.inventoryOrderStore.listDeletedDistributors(options);
            this.distributorsList = store_1.inventoryOrderStore.distributors;
        };
        /**
         * Set the value of selectedDistributor from the item clicked from the drop down
         */
        this.handleDistributorSelect = (distributor) => {
            this.selectedDistributor = distributor;
        };
        this.handleCancelDistributorAdd = () => {
            this.showDistributorAddForm = false;
        };
        this.handleAddDistributor = async (distributorToAdd) => {
            store_1.inventoryOrderStore.showLoader = true;
            /** If duplicate or empty string, do not save, return */
            if (distributorToAdd.name === "") {
                store_1.inventoryOrderStore.showLoader = false;
                alert("Empty value detected. No distributor added.");
                return;
            }
            if (this.distributorsList.some(distributor => distributor.distributor.toLowerCase().trim() ===
                distributorToAdd.name.toLowerCase().trim())) {
                store_1.inventoryOrderStore.showLoader = false;
                alert("Duplicate distributor name detected. No distributor added.");
                return;
            }
            const distributorAdded = await store_1.inventoryOrderStore.createDistributor(distributorToAdd);
            // Resest distributor add field
            if (distributorAdded) {
                this.distributorToAdd = "";
            }
            await this.loadDistributors();
            // hide the distributor add form
            this.showDistributorAddForm = false;
        };
        this.handleDistributorRemove = async () => {
            store_1.inventoryOrderStore.showLoader = true;
            await store_1.inventoryOrderStore.deleteDistributor(this.distributorToRemove);
            // C-097_Distributor_UAT Disable 
            let options = {
                page: this.page,
                limit: this.limit //For pagination //C-097
            };
            if (this.showDisabled) {
                await this.loadDeletedDistributors(options);
            }
            else {
                await this.loadDistributors(options);
            }
            this.showDistributorRemoveConfirmation = false;
            this.distributorToRemove = null;
        };
        this.handleDistributorActivateAndRestoreInv = async () => {
            store_1.inventoryOrderStore.showLoader = true;
            const restore = true;
            await store_1.inventoryOrderStore.activateDistributor(this.distributorToActivate, restore);
            // this.showDisabled = false;
            // await this.loadDistributors();
            // C-097_Distributor_UAT Disable 
            let options = {
                page: this.page,
                limit: this.limit //For pagination //C-097
            };
            if (this.showDisabled) {
                await this.loadDeletedDistributors(options);
            }
            else {
                await this.loadDistributors(options);
            }
            this.showDistributorActivateConfirmation = false;
            this.distributorToActivate = null;
        };
        this.handleDistributorActivateAndClearInv = async () => {
            store_1.inventoryOrderStore.showLoader = true;
            const restore = false;
            await store_1.inventoryOrderStore.activateDistributor(this.distributorToActivate, restore);
            // C-097_Distributor_UAT Disable 
            let options = {
                page: this.page,
                limit: this.limit //For pagination //C-097
            };
            // this.showDisabled = false;
            // await this.loadDistributors();
            if (this.showDisabled) {
                await this.loadDeletedDistributors(options);
            }
            else {
                await this.loadDistributors(options);
            }
            this.showDistributorActivateConfirmation = false;
            this.distributorToActivate = null;
        };
        /**
         * Set the value of selectedDistributor from the item clicked the distributor overview list
         */
        this.handleDistributorOverviewSelect = (distributor) => () => {
            this.loading = true;
            this.selectedDistributor = distributor;
            router_1.RouteManager.transitionTo(`/order/distributors/${this.selectedDistributor.id}`);
        };
        this.handleDistributorUpdate = async (distributor) => {
            store_1.inventoryOrderStore.showLoader = true;
            // disallow empty value for name
            if (distributor.distributor === "") {
                store_1.inventoryOrderStore.showLoader = false;
                alert("Empty value detected. No distributor added.");
                return;
            }
            if (distributor.contactEmailTwo) {
                distributor.contactEmail = distributor.contactEmail.concat(";", distributor.contactEmailTwo);
            }
            if (distributor.contactEmailThree) {
                distributor.contactEmail = distributor.contactEmail.concat(";", distributor.contactEmailThree);
            }
            await store_1.inventoryOrderStore.updateDistributor(distributor);
            // await this.loadDistributors();
            // C-097_Distributor_UAT Disable 
            let options = {
                page: this.page,
                limit: this.limit //For pagination //C-097
            };
            if (this.showDisabled) {
                await this.loadDeletedDistributors(options);
            }
            else {
                await this.loadDistributors(options);
            }
        };
        /**
         * Returns the list of distributors array
         */
        this.renderDistributorOverviewList = (distributor, index) => (React.createElement(React.Fragment, { key: index },
            React.createElement(list_item_1.MaterialListItem, { className: distributor.deletedAt
                    ? "disabled-site-accent"
                    : "", onClick: this.manageDistributorsMode
                    ? () => {
                        this.showOverviewChildren.set(index, !this.showOverviewChildren.get(index));
                    }
                    : this.handleDistributorOverviewSelect(distributor) },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: distributor.id }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: distributor.distributor }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement(contact_email_1.ContactEmail, { emails: distributor.contactEmail }) })),
            React.createElement(Collapse_1.default, { in: this.manageDistributorsMode && !distributor.deletedAt && this.showOverviewChildren.get(index) },
                React.createElement(distributor_edit_form_1.DistributorEditForm, { onDelete: () => {
                        this.distributorToRemove = distributor;
                        this.showDistributorRemoveConfirmation = true;
                    }, onCancel: () => {
                        this.showOverviewChildren.set(index, !this.showOverviewChildren.get(index));
                    }, distributor: distributor, onViewInv: this.handleDistributorOverviewSelect(distributor), onSave: this.handleDistributorUpdate })),
            React.createElement(Collapse_1.default, { in: this.manageDistributorsMode && distributor.deletedAt && this.showOverviewChildren.get(index) },
                React.createElement(distributor_edit_form_1.DistributorEditForm, { onDelete: () => {
                        this.distributorToActivate = distributor;
                        this.showDistributorActivateConfirmation = true;
                    }, onCancel: () => {
                        this.showOverviewChildren.set(index, !this.showOverviewChildren.get(index));
                    }, distributor: distributor, isDisabled: distributor.deletedAt ? true : false, onViewInv: this.handleDistributorOverviewSelect(distributor), onSave: this.handleDistributorUpdate }))));
        this.renderDistributorOverview = () => (React.createElement(list_1.MaterialList, { columns: distributorColumns, order: "ASC", orderBy: "", rows: this.distributorsList || [], renderRow: this.renderDistributorOverviewList, resizableheader: true, customClass: "custom-material-list__distributors-list" }));
        this.handleDisabledToggle = () => {
            this.showDisabled = !this.showDisabled;
            this.page = 1;
            // C-097_Distributor_UAT Disable 
            let options = {
                page: this.page,
                limit: this.limit //For pagination //C-097
            };
            if (this.showDisabled) {
                this.loadDeletedDistributors(options);
            }
            else {
                this.loadDistributors(options);
            }
            // this.loadProviders();
        };
        // C-097 handle pagination input
        this.handleKeyDown = async () => {
            if (this.page === Number(""))
                return;
            // (this.page !== inventoryOrderStore.currentPage) && this.listDistributors();
            // C-097_Distributor_UAT Disable 
            let options = {
                page: this.page,
                limit: this.limit //For pagination //C-097
            };
            if (this.showDisabled) {
                await this.loadDeletedDistributors(options);
            }
            else {
                await this.loadDistributors(options);
            }
        };
        this.handleManageDistToggle = () => {
            // C-097_Distributor_UAT Disable 
            let options = {
                page: this.page,
                limit: this.limit //For pagination //C-097
            };
            this.showDisabled = false;
            this.manageDistributorsMode = !this.manageDistributorsMode;
            this.manageDistributorsPurchaseList = !this.manageDistributorsPurchaseList;
            this.loadDistributors(options);
        };
    }
    // C-097_Distributor_UAT Disable
    async componentDidMount() {
        const options = {
            page: this.page,
            limit: this.limit //For pagination //C-097
        };
        store_1.inventoryOrderStore.showLoader = true;
        await this.loadDistributors(options);
        // C-097_Distributors
        this.totalPages = store_1.inventoryOrderStore.totalProviderPage;
    }
    // C-097_Distributors
    render() {
        var _a, _b, _c;
        return (React.createElement("div", { className: "inventory-order__distributors distributor-wrapper" },
            React.createElement(material_ui_1.Typography, { variant: "display1" }, "Distributors"),
            this.showDistributorAddForm && (React.createElement(distributor_add_form_1.DistributorAddForm, { onCancel: this.handleCancelDistributorAdd, onSave: this.handleAddDistributor })),
            !this.showDistributorAddForm ? (React.createElement("div", { className: "distributor__buttons" },
                store_2.usersStore.permissions.UpdateDistributors && (React.createElement("div", null,
                    React.createElement(switch_1.MaterialSwitch, { label: "Manage Distributor Account", value: "manageDistributorMode", onChange: this.handleManageDistToggle, checked: this.manageDistributorsMode }),
                    React.createElement(switch_1.MaterialSwitch, { label: "Manage Distributor Purchase List", value: "manageDistributorPurchaseList", onChange: this.handleManageDistToggle, checked: this.manageDistributorsPurchaseList }))),
                (!((_a = store_2.usersStore.user.value) === null || _a === void 0 ? void 0 : _a.distAdmin) && !((_b = store_2.usersStore.user.value) === null || _b === void 0 ? void 0 : _b.distManager) && !((_c = store_2.usersStore.user.value) === null || _c === void 0 ? void 0 : _c.distUser)) // C-047
                    ? this.manageDistributorsMode && (React.createElement("div", { className: "distributor__buttons--right" },
                        React.createElement(switch_1.MaterialSwitch, { label: "Show Disabled", value: "showDisabled", onChange: this.handleDisabledToggle, checked: this.showDisabled }),
                        React.createElement(button_1.MaterialButton, { onClick: () => {
                                this.showDistributorAddForm = true;
                            }, variant: "flat" }, "Add distributor"))) : '')) : null,
            !this.showDistributorAddForm ? this.renderDistributorOverview() : null,
            React.createElement("div", { className: "pagination-container-header" },
                React.createElement("button", { className: "btn-pagination", onClick: async () => {
                        if (this.page === 1)
                            return;
                        this.page--;
                        // C-097_Distributor_UAT Disable 
                        let options = {
                            page: this.page,
                            limit: this.limit
                        };
                        if (this.showDisabled) {
                            await this.loadDeletedDistributors(options);
                        }
                        else {
                            await this.loadDistributors(options);
                        }
                    } }, "Previous"),
                React.createElement("div", { className: "pagination-container" },
                    React.createElement("p", null, "Page"),
                    React.createElement("div", { style: { display: 'contents' } },
                        React.createElement("div", { className: "cstmPaginationInput-Wrapper " },
                            React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "pagination-input", autoFocus: true, type: "text", onChange: (e) => {
                                    const value = Number(e.target.value);
                                    if (value >= 1 && value <= store_1.inventoryOrderStore.totalProviderPage) {
                                        this.page = value;
                                    }
                                    else {
                                        if (e.target.value <= store_1.inventoryOrderStore.totalProviderPage) {
                                            this.page = value;
                                        }
                                        else {
                                            e.target.value = this.page;
                                        }
                                    }
                                }, onKeyDown: () => { }, onKeyDownEnterPress: this.handleKeyDown, value: this.page || "" })),
                        React.createElement("div", null, "of"),
                        React.createElement("div", null, store_1.inventoryOrderStore.totalProviderPage)),
                    React.createElement("select", { className: "pagination-input", onChange: async (e) => {
                            this.limit = Number(e.target.value);
                            this.page = 1;
                            // C-097_Distributor_UAT Disable 
                            let options = {
                                page: this.page,
                                limit: this.limit
                            };
                            if (this.showDisabled) {
                                await this.loadDeletedDistributors(options);
                            }
                            else {
                                await this.loadDistributors(options);
                            }
                        }, defaultValue: this.limit },
                        React.createElement("option", { value: "5" }, "5 rows"),
                        React.createElement("option", { value: "10" }, "10 rows"),
                        React.createElement("option", { value: "25" }, "25 rows"),
                        React.createElement("option", { value: "50" }, "50 rows"),
                        React.createElement("option", { value: "100" }, "100 rows"))),
                React.createElement("button", { className: "btn-pagination1", onClick: async () => {
                        if (this.page === store_1.inventoryOrderStore.totalProviderPage)
                            return;
                        this.page++;
                        // C-097_Distributor_UAT Disable 
                        let options = {
                            page: this.page,
                            limit: this.limit
                        };
                        if (this.showDisabled) {
                            await this.loadDeletedDistributors(options);
                        }
                        else {
                            await this.loadDistributors(options);
                        }
                    } }, "Next")),
            this.showDistributorRemoveConfirmation && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Delete", cancelText: "Cancel", message: `Are you sure you want to delete this distributor?<br />This might take a few moments.`, onCancel: () => {
                    this.distributorToRemove = null;
                    this.showDistributorRemoveConfirmation = false;
                }, onConfirm: this.handleDistributorRemove, title: "Delete Confirmation", shouldDisableConfirm: this.loading })),
            this.showDistributorActivateConfirmation && (React.createElement(modal_1.Modal, { onCancel: () => {
                    this.distributorToActivate = null;
                    this.showDistributorActivateConfirmation = false;
                }, buttons: [
                    React.createElement(button_1.MaterialButton, { onClick: async () => this.handleDistributorActivateAndRestoreInv(), primary: true, style: { height: "fit-content" }, disabled: this.loading }, "Activate & Restore"),
                    React.createElement(button_1.MaterialButton, { style: { height: "fit-content" }, onClick: () => this.handleDistributorActivateAndClearInv(), disabled: this.loading }, "Activate & Clear"),
                    React.createElement(button_1.MaterialButton, { onClick: () => {
                            this.distributorToActivate = null;
                            this.showDistributorActivateConfirmation = false;
                        }, style: { height: "fit-content" }, disabled: this.loading }, "Go Back")
                ] },
                React.createElement("h1", { style: { margin: "0 auto" } }, "Restore Inventory Confirmation"),
                React.createElement("p", null, "You're about to reactivate the selected distributor."),
                React.createElement("h4", { style: { margin: "0 auto" } }, "Do you want to restore the previous inventory for this distributor?"),
                React.createElement("p", null, "Restoring previous inventory might take a few moments."))),
            store_1.inventoryOrderStore.showLoader ? (
            // <div className="ui-form__loading-bg ui-form__loading-bg--loading" > caused loader issue i removed class only 2025-02-01 22:05:00
            React.createElement("div", { className: "ui-form__loading-bg" },
                React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "ui-form__loading-indicator" }))) : ("")));
    }
};
__decorate([
    mobx_1.observable
], DistributorsList.prototype, "selectedDistributor", void 0);
__decorate([
    mobx_1.observable
], DistributorsList.prototype, "distributorToAdd", void 0);
__decorate([
    mobx_1.observable
], DistributorsList.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], DistributorsList.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], DistributorsList.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], DistributorsList.prototype, "distributorsList", void 0);
__decorate([
    mobx_1.observable
], DistributorsList.prototype, "manageDistributorsMode", void 0);
__decorate([
    mobx_1.observable
], DistributorsList.prototype, "manageDistributorsPurchaseList", void 0);
__decorate([
    mobx_1.observable
], DistributorsList.prototype, "showDistributorRemoveConfirmation", void 0);
__decorate([
    mobx_1.observable
], DistributorsList.prototype, "showDistributorActivateConfirmation", void 0);
__decorate([
    mobx_1.observable
], DistributorsList.prototype, "distributorToRemove", void 0);
__decorate([
    mobx_1.observable
], DistributorsList.prototype, "distributorToActivate", void 0);
__decorate([
    mobx_1.observable
], DistributorsList.prototype, "showDistributorAddForm", void 0);
__decorate([
    mobx_1.observable
], DistributorsList.prototype, "showOverviewChildren", void 0);
__decorate([
    mobx_1.observable
], DistributorsList.prototype, "loading", void 0);
__decorate([
    mobx_1.observable
], DistributorsList.prototype, "showDisabled", void 0);
__decorate([
    mobx_1.observable
], DistributorsList.prototype, "page", void 0);
__decorate([
    mobx_1.observable
], DistributorsList.prototype, "limit", void 0);
__decorate([
    mobx_1.observable
], DistributorsList.prototype, "totalPages", void 0);
DistributorsList = __decorate([
    mobx_react_1.observer
    // export class DistributorsTab extends Component<IProps> {
], DistributorsList);
exports.DistributorsList = DistributorsList;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/distributors/components/distributor-list/distributor-list.tsx
// module id = 3514
// module chunks = 0